import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import refreshIcon from "../../../assets/icon-white/refresh-white.svg";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import { BsSearch } from "react-icons/bs";
import dateFormat from "dateformat";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import { useRef } from "react";

function Newmember() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  let componentRef = useRef();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/newmember/");
    const name = result.data.data.map((value) => value.name);
    setData(result.data.data);
    setAutoComplete(name);
    setGetSuccess(true);
    autoDelete(result.data.data);
  };
  //atomatis delete
  const autoDelete = (data) => {
    const d = new Date();
    data &&
      data.forEach(async (item) => {
        if (item.out !== null) {
          if (
            dateFormat(new Date(item.out), "d-mm-yyyy") !==
            dateFormat(d, "d-mm-yyyy")
          ) {
            await axios.delete(
              `https://mobile.amospa.com/newmember/${item.id}`
            );
          }
        }
      });
  };

  //Handle search
  const keys = ["name"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const member = handleSearch();
  const dataTable = member ? member : currentItems;

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  //Header csv
  const headers = [
    { label: "Guest Name", key: "name" },
    { label: "Checkin", key: "in" },
    { label: "Checkout", key: "out" },
    { label: "Mode", key: "mode" },
    { label: "Notes", key: "notes" },
  ];

  //XLSX
  const handleExportXlsx = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataTable);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "NewMember.xlsx");
  };

  useEffect(() => {
    getData();
    autoDelete();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, getSuccess]);

  return (
    <div className="chekin">
      <div className="chekin-header pt-2 m-0">
        <div className="sum-chekin">
          <h3 className="text-white">
            Total New Member:{" "}
            <span style={{ color: "#FFD700" }}>{data && data.length}</span>
          </h3>
        </div>
        <div className="chekin-refresh">
          <button
            className="btn-chekin-refresh bg-success text-white fw-bold p-2"
            onClick={() => window.location.reload()}
          >
            <img src={refreshIcon} alt="" /> Refresh
          </button>
        </div>
      </div>
      <div className="chekin-list-header">
        <span className="d-flex align-items-center">
          <h3 className="text-white ms-3 me-2 ">List New Member Today</h3>
          <p>
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{" "}
          </p>
        </span>

        <span className="d-flex">
          <button
            onClick={handleExportXlsx}
            className="btn text-decoration me-1 fw-bold"
            style={{
              background: "#FFD700",
              color: "black",
              outline: "none",
            }}
          >
            XLSX
          </button>
          <CSVLink
            data={dataTable}
            headers={headers}
            filename="Checkin Guest"
            className="btn  text-decoration-none me-1 fw-bold"
            separator={";"}
            style={{ background: "#FFD700", color: "black" }}
          >
            CSV
          </CSVLink>
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  className="btn text-decoration me-1 fw-bold"
                  style={{ background: "#FFD700", color: "black" }}
                >
                  PRINT
                </button>
              );
            }}
            content={() => componentRef}
            documentTitle="new document"
            pageStyle="print"
            className="bg-success"
          />
          {/* <Link to={"/homepage/members/add-chekin"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD GUEST
            </button>
          </Link> */}
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover ref={(el) => (componentRef = el)}>
        <thead>
          <tr>
            <th>NO</th>
            <th>Guest Name</th>
            <th>Date</th>
            {/* <th>Checkout</th> */}
            <th>Mode</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>
                  {dateFormat(new Date(item.in), "d-mmmm-yyyy, HH:MM:ss")}
                </td>
                {/* <td>
                  {dateFormat(new Date(item.out), "d-mmmm-yyyy, HH:MM:ss")}
                </td> */}
                <td>{item.mode}</td>
                <td>{item.notes}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
    </div>
  );
}

export default Newmember;
